<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/13Q9YNv/tc-custom/9781913682903.jpg?1731055856387" alt="This image is the cover for the book Their Final Act, The DI Alec McKay Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Their Final Act, The DI Alec McKay Series
      </h1>
      <p class="bookDescription body article font2">
        <b>A serial killer is targeting washed-up entertainers in the Scottish Highlands in this gritty crime thriller by the author of <i>Candles and Roses</i>.</b><br/>  <br/> Former comic Jimmy McGuire is found dead on the streets of Inverness, his body garroted. Years ago, McGuire had been half of a promising double-act until his partner, Jack Dingwall, was convicted of rape. Soon after, a second corpse is found in an abandoned industrial site on the edge of the Moray Firth—also garroted. Identified as a former musician turned record producer, it is learned that he had also been accused of rape.<br/><br/> Meanwhile, Det. Inspector Alec McKay and Chief Inspector Helena Grant are still wrestling with the fallout from a recent case following a devastating acquittal. As the body count rises, the police think they have the killer in their sights. But McKay is concerned that the evidence is too neat. And as the trail leads to a final victim yet to come, time is running out to find the real killer.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Alex Walters
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Bloodhound Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?eed6e3a2